import { DateTime } from "luxon";
import moment from 'moment';

//e.g: from "2022-09-27T16:07:42.717754842Z" to "Sep 27, 2022, 9:37 PM"
export const getIsoToMediumFormatDatetime = (datetime) => {
    if (datetime === null || datetime === undefined) {
        return 'UNKNOWN';
    }
    return DateTime.fromISO(datetime)
        .toLocaleString(DateTime.DATETIME_MED);
};

export const format_yyyy_mm_dd_to_DATETIME_MED = dateStr => {
    if (dateStr === null || dateStr === undefined) {
        return 'UNKNOWN';
    }
    if(dateStr?.includes("/")){
        return DateTime.fromFormat(dateStr, "yyyy/MM/dd")
            .toLocaleString(DateTime.DATE_MED);
    }
    return DateTime.fromFormat(dateStr, "yyyy-MM-dd")
        .toLocaleString(DateTime.DATE_MED);
}

export const getAgeInYrsMonths = dateStr => {
    if (dateStr === null || dateStr === undefined) {
        return 'UNKNOWN';
    }
    let date;
    if(dateStr?.includes("/")){
        date = DateTime.fromFormat(dateStr, "yyyy/MM/dd");
    } else{
        date = DateTime.fromFormat(dateStr, "yyyy-MM-dd");
    }
    const yrsMonth = DateTime.now().diff(date, ['years', 'months']).toObject();
    return {"years": yrsMonth.years, "months": (Math.round(yrsMonth.months))};
}

export const getAgeInYrsMonthsDisplay  = dateStr => {
    if (dateStr === null || dateStr === undefined) {
        return 'UNKNOWN';
    }
    const {years, months} = getAgeInYrsMonths(dateStr);
    return `${years}yrs, ${months}m old`;

};

export const getBackendFormatDate_yyyy_MM_dd = (datetime) => {
    return DateTime.fromISO(datetime).toFormat("yyyy-MM-dd");
}

export const getBackendFormatDate_yyyy_MM_dd_Range = (datetime) => {
    const dateTimeObject = DateTime.fromJSDate(datetime);
    const formattedDate = dateTimeObject.toFormat("yyyy-MM-dd");
    return formattedDate;
};

export const getBackendFormatDate_yyyy_MM_dd_Plus = (datetime,days) => {
    const dateTimeObject = DateTime.fromJSDate(datetime).plus({days: days});
    const formattedDate = dateTimeObject.toFormat("yyyy-MM-dd")
    return formattedDate;
};

export const getBackendFormatDate_yyyy_MM_dd_Minus = (datetime,days) => {
    const dateTimeObject = DateTime.fromJSDate(datetime).minus({days: days});
    const formattedDate = dateTimeObject.toFormat("yyyy-MM-dd");
    return formattedDate;
};
  
export const getRegion = user => {
  return user?.address?.region ?? 'UNKNOWN';
};

export const TIMEZONES = {
    PACIFIC:  {isoStr: 'America/Los_Angeles', display: 'Pacific/Las-Vegas/ Los-Angeles'},
    MOUNTAIN: {isoStr: 'America/Denver', display: 'Mountain-Time/Denver'},
    CENTRAL:  {isoStr: 'America/Chicago', display: 'Central-Time/Chicago'},
    EASTERN:  {isoStr: 'America/New_York', display: 'Easter/New-York'},
};

export const momentPastDate = (days) => {
    return moment(new Date()).subtract(days, 'days');
}
export const momentFutureDate = (days) => {
    return moment(new Date()).add(days, 'days');
}

export const momentDateBkendFormat = date => {
    return moment(date).format('YYYY-MM-DD');
}

export const formatUSMobileNum = (number) => {
    // If number is empty or null, return empty string
    if(!number?.trim()?.length) return '';

    // Remove leading +1 from the number if present
    number = number?.trim();
    if(number?.startsWith('+1')){
        number = number.replace('+1', '')?.trim();
    }

    // Remove all non-digit characters from the number
    number = number.replace(/\D/g, '')?.trim();

    // Format the number as (xxx)-xxx-xxxx
    number = '(' + number.substring(0, 3) + ')-' + number.substring(3, 6) + '-' + number.substring(6);

    // Return the formatted number
    return number;
}

export const capitalizeWords = (str) => {
    return str?.split('_')?.map(word => word?.charAt(0)?.toUpperCase() + word?.slice(1)?.toLowerCase())?.join(' ');
};

export const isValidValue = (value) => {
    if (value === null || value === undefined || value === '' || value === 'null' || value === 'undefined') {
        return false;
    }
    return value?.length > 0;
}

export const convertEpochToDate =(createdEpoch) => {
    // Convert seconds to milliseconds (Epoch timestamps are usually in seconds)
    const milliseconds = createdEpoch * 1000;
  
    // Create a new Date object using the milliseconds
    const dateObject = new Date(milliseconds);
  
    // Get the month, day, and year from the date object
    const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
    const day = dateObject.getDate();
    const monthIndex = dateObject.getMonth();
    const year = dateObject.getFullYear() % 100; // Get only last two digits of the year
  
    // Format the date as 'DD Mon 'YY
    const formattedDate = `${day} ${monthNames[monthIndex]}'${year.toString().padStart(2, "0")}`;
  
    return formattedDate;
  }

export function getAlphaNumeric(inputString) {
    // Use regular expression to match only alphanumeric characters
    var alphanumericRegex = /[a-zA-Z0-9]/g;

    // Use the match method to get an array of alphanumeric characters
    var resultArray = inputString.match(alphanumericRegex);

    // Use the join method to concatenate the array into a string
    var resultString = resultArray ? resultArray.join('') : '';

    return resultString;
}

export function replaceNextLineCharWithNextLineTag(inputString) {
    const strArr = inputString?.trim()?.split('\\n');
    if(strArr?.length > 1){
        const s = strArr?.join('<br>');
        console.log(s);
        return s;
    }
    return inputString;
}

export function convertDateToUSFormat(dateString) {
    // Parse the input date string into a Date object
    const date = new Date(dateString);
    // Get the month (0-indexed, so we add 1) and format it to 2 digits
    const month = String(date.getMonth() + 1).padStart(2, "0");
    // Get the day of the month and format it to 2 digits
    const day = String(date.getDate()).padStart(2, "0");
    // Get the year
    const year = date.getFullYear();
    // Format the date as 'mm-dd-yyyy'
    const formattedDate = `${month}-${day}-${year}`;
  
    return formattedDate;
  }
  
  export function getPhoneNumber(phone) {
    if (!phone) {
      return ""; // No phone number provided
    }
    // Remove all non-numeric characters (ignores spaces, dashes, parentheses, etc.)
    const numericPhone = phone.replace(/[^0-9]/g, "");
    // Handle phone numbers with country codes (assuming 10-digit US-style or international)
    if (numericPhone.length === 11 && numericPhone.startsWith("1")) {
      return numericPhone.slice(1); // For US/Canada, remove the country code '1'
    }
    // For standard 10-digit phone numbers
    if (numericPhone.length === 10) {
      return numericPhone; // Valid 10-digit number
    }
    // If the number is invalid or doesn't match the expected format
    return "";
  }
  
  export function scheduleFollowUp(patientInfo, region) {
    const prefillData = {
      name: patientInfo?.name || "",
      email: patientInfo?.email || "",
      mobile: getPhoneNumber(patientInfo?.phoneNumber) || "",
      dob: convertDateToUSFormat(patientInfo?.dob) || "",
      pronoun: patientInfo?.pronoun || "",
      notes: "Follow up appointment"
    };
  
    // Handle pronouns (capitalize and split by commas)
    const handlePronouns = pronouns => {
      if (!pronouns) return "";
  
      if (!pronouns.includes(",")) {
        return [pronouns?.charAt(0)?.toUpperCase() + pronouns?.slice(1) || ''];
      }
  
      const pronounList = pronouns
        .split(",") // Split by commas
        .map(pronoun => {
          return pronoun
            .split("/") // Split by '/'
            .map(word => (word?.charAt(0)?.toUpperCase() || '') + word?.slice(1) || '') // Capitalize first letter of each part
            .join("/"); // Join back with '/'
        });
  
      return pronounList;
    };
  
    const formattedPronouns = handlePronouns(patientInfo?.pronoun);
  
    // Convert to URL parameters format
    const urlParams = new URLSearchParams();
  
    // Add all prefill data to the URLSearchParams
    Object.keys(prefillData).forEach(key => {
      if (key === "pronoun" && formattedPronouns.length) {
        formattedPronouns.forEach(pronoun => {
          urlParams.append("pronoun", pronoun); // Add multiple pronoun values
        });
      } else {
        urlParams.append(key, prefillData[key]);
      }
    });
  
    // Convert URLSearchParams to string
    const tbdSiteLink = process.env.REACT_APP_MAIN_STORE_SITE_URL;
    const calendarState = region === "NV" ? "/clinic/vegas" : region === "CO" ? "/clinic/denver-larimer" : "/clinic/vegas";
    const encodedCalendarParams = encodeURIComponent(urlParams.toString());

    const tbdUrlWithCalendarLink = `${tbdSiteLink}${calendarState}?calendar=${encodedCalendarParams}`;
  
    window.open(tbdUrlWithCalendarLink, "_blank");
  }
  
  export const getSenderName = (msg, patientDetail) => {
    const isPatient = msg?.fromField === "PATIENT";
    const preferredName = patientDetail?.preferredName?.trim();

    if (isPatient) {
      if (preferredName && preferredName.toLowerCase() !== "n/a") {
        return preferredName;
      }

      const firstName = msg?.fromUser?.firstName?.trim() || "";
      const lastName = msg?.fromUser?.lastName?.trim() || "";

      return `${firstName} ${lastName}`.trim() || msg?.from || "UNKNOWN";
    }

    const firstName = msg?.fromUser?.firstName?.trim() || "";
    const lastName = msg?.fromUser?.lastName?.trim() || "";

    return `${firstName} ${lastName}`.trim() || msg?.from || "UNKNOWN";
  };
  
  export const getSenderInitial = (msg, patientDetail) => {
    const isPatient = msg?.fromField === "PATIENT";
    const preferredName = patientDetail?.preferredName?.trim();

    if (isPatient) {
      if (preferredName && preferredName.toLowerCase() !== "n/a") {
        return preferredName.charAt(0) || "";
      }

      return msg?.fromUser?.firstName?.charAt(0) || msg?.from?.charAt(0) || "";
    }

    return msg?.fromUser?.firstName?.charAt(0) || msg?.from?.charAt(0) || "";
  };